import { lazy } from "react"
import { Routes, Route } from "react-router-dom"

import RequireAuth from "./require-auth"
import RequireNoAuth from "./require-no-auth"
import Maintenance from "../error/maintenance"
import NoMatch from "../../components/no-match"
import Events from "pages/events"
import AssignationsRouter from "pages/assignations"

const Auth = lazy(
  () => import(/* webpackChunkName: "[auth]" */ "../../pages/auth")
)
const Home = lazy(
  () => import(/* webpackChunkName: "[Home]" */ "../../pages/home")
)
const Profile = lazy(
  () => import(/* webpackChunkName: "[profile]" */ "../../pages/user")
)

const Router: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <RequireAuth>
            <Home />
          </RequireAuth>
        }
      />
      <Route
        path="events/*"
        element={
          <RequireAuth>
            <Events />
          </RequireAuth>
        }
      />
      <Route
        path="assignations/*"
        element={
          <RequireAuth>
            <AssignationsRouter />
          </RequireAuth>
        }
      />
      <Route
        path="/auth/*"
        element={
          <RequireNoAuth>
            <Auth />
          </RequireNoAuth>
        }
      />
      <Route
        path="/user/profile/*"
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />
      <Route path="/maintenance" element={<Maintenance />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  )
}

export default Router
